import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import API_URL from '../config';
import './ManageSlots.css'; // Assuming you have a CSS file to style this component

const ManageSlots = () => {
  const [rooms, setRooms] = useState([]);
  const [selectedRoom, setSelectedRoom] = useState('');
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [slots, setSlots] = useState([]);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchRooms = async () => {
      try {
        const token = localStorage.getItem('token');

        if (!token || typeof token !== 'string') {
          setMessage('Session expirée, veuillez vous reconnecter.');
          navigate('/login');
          return;
        }

        const response = await axios.get(`${API_URL}/api/rooms`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setRooms(response.data);
        if (response.data.length > 0) {
          setSelectedRoom(response.data[0].name);
        }
      } catch (error) {
        setMessage('Erreur lors du chargement des salles.');
      }
    };
    fetchRooms();
  }, [navigate]);

  useEffect(() => {
    if (selectedRoom) {
      const fetchSlots = async () => {
        try {
          const token = localStorage.getItem('token');

          if (!token || typeof token !== 'string') {
            setMessage('Session expirée, veuillez vous reconnecter.');
            navigate('/login');
            return;
          }

          const response = await axios.get(`${API_URL}/api/rooms/${selectedRoom}/availability`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          setSlots(response.data || []);
        } catch (error) {
          setMessage('Erreur lors du chargement des créneaux.');
        }
      };
      fetchSlots();
    }
  }, [selectedRoom, navigate]);

  const handleAddSlot = async () => {
    try {
      const token = localStorage.getItem('token');

      if (!token || typeof token !== 'string') {
        setMessage('Session expirée, veuillez vous reconnecter.');
        navigate('/login');
        return;
      }

      await axios.post(
        `${API_URL}/api/rooms/${selectedRoom}/availability`,
        { startTime, endTime },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setMessage('Créneau ajouté avec succès !');
      setStartTime('');
      setEndTime('');
      setSlots([...slots, { startTime, endTime }]);
    } catch (error) {
      setMessage("Erreur lors de l'ajout du créneau.");
    }
  };

  const handleDeleteSlot = async (startTime, endTime) => {
    try {
      const token = localStorage.getItem('token');

      if (!token || typeof token !== 'string') {
        setMessage('Session expirée, veuillez vous reconnecter.');
        navigate('/login');
        return;
      }

      await axios.delete(`${API_URL}/api/rooms/${selectedRoom}/availability`, {
        headers: { Authorization: `Bearer ${token}` },
        data: { startTime, endTime },
      });
      setSlots(slots.filter(slot => slot.startTime !== startTime || slot.endTime !== endTime));
    } catch (error) {
      setMessage('Erreur lors de la suppression du créneau.');
    }
  };

  const isDateComplete = (date) => {
    return date && date.length === 16; // Check if date is fully filled (YYYY-MM-DDTHH:mm)
  };

  return (
    <div className="manage-slots-container">
      <h2>Gestion des créneaux</h2>
      {message && <p className="message">{message}</p>}
      <div className="form-section">
        <label htmlFor="room-select">Choisissez une salle :</label>
        <select
          id="room-select"
          value={selectedRoom}
          onChange={(e) => setSelectedRoom(e.target.value)}
        >
          <option value="">-- Sélectionner une salle --</option>
          {rooms.map((room) => (
            <option key={room._id} value={room.name}>{room.name}</option>
          ))}
        </select>

        <div className="slot-inputs">
          <input
            type="datetime-local"
            value={startTime}
            onChange={(e) => setStartTime(e.target.value)}
            className="datetime-input"
            step="3600"  // Cette ligne force les heures pleines
          />
          <input
            type="datetime-local"
            value={endTime}
            onChange={(e) => setEndTime(e.target.value)}
            className="datetime-input"
            step="3600"  // Cette ligne force les heures pleines
          />
          <button
            className="add-slot-button"
            onClick={handleAddSlot}
            disabled={!isDateComplete(startTime) || !isDateComplete(endTime)}
          >
            Ajouter le créneau
          </button>
        </div>
      </div>

      <h3>Disponibilités actuelles</h3>
      <ul className="slots-list">
        {Array.isArray(slots) && slots.map(slot => (
          <li key={`${slot.startTime}-${slot.endTime}`}>
            Début : {new Date(slot.startTime).toLocaleString()} - Fin : {new Date(slot.endTime).toLocaleString()}
            <button className="delete-slot-button" onClick={() => handleDeleteSlot(slot.startTime, slot.endTime)}>
              Supprimer
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ManageSlots;